/*
 * @Description:增加app比例的默认值
 * @Company: TRS
 * @Date: 2019-12-12 19:59:55
 * @LastEditors: cc
 */
'use strict';
angular.module('mangeProAppSiteServiceModule', []).controller('mangeProAppSiteModCtrl', [
    '$scope',
    '$element',
    '$validation',
    '$timeout',
    '$q',
    '$modalInstance',
    '$stateParams',
    'params',
    'productMangageMentAppService',
    'trsHttpService',
    'modalDialog',
    function(
        $scope,
        $element,
        $validation,
        $timeout,
        $q,
        $modalInstance,
        $stateParams,
        params,
        productMangageMentAppService,
        trsHttpService,
        modalDialog
    ) {
        initStatus();
        console.log(params);
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
        $scope.confirm = function() {
            $validation
                .validate($scope.addAndModForm)
                .success(function() {
                    if ($scope.isSiteExist == '"true"') {
                        modalDialog.alertType('该站点名已经存在', '', 'error', false);
                        return;
                    }
                    if ($scope.examEng == 'false') {
                        modalDialog.alertType('存放位置已存在', '', 'error', false);
                        return;
                    }
                    $scope.newsite.NEWSPICSIZE = $scope.newPic.newsPicWidth + ',' + $scope.newPic.newsPicHeight;
                    $scope.newsite.NEWSZTPICSIZE = $scope.newPic.newsZtPicWidth + ',' + $scope.newPic.newsZtPicHeight;
                    $scope.newsite.NEWSBIGPICSIZE = $scope.newPic.newsBigPicWidth + ',' + $scope.newPic.newsBigPicHeight;
                    $scope.newsite.PICSIZE = $scope.newPic.picWidth + ',' + $scope.newPic.picHeight;
                    $scope.newsite.PICBIGSIZE = $scope.newPic.picBigWidth + ',' + $scope.newPic.picBigHeight;
                    $scope.newsite.PICZTPICSIZE = $scope.newPic.picZtWidth + ',' + $scope.newPic.picZtHeight;
                    $scope.newsite.SPECSIZE = $scope.newPic.specWidth + ',' + $scope.newPic.specHeight;
                    $scope.newsite.SPECBIGSIZE = $scope.newPic.specBigWidth + ',' + $scope.newPic.specBigHeight;
                    $scope.newsite.WEBPAGESIZE = $scope.newPic.webPageWidth + ',' + $scope.newPic.webPageHeight;
                    $scope.newsite.WEBPAGEBIGSIZE = $scope.newPic.webPageBigWidth + ',' + $scope.newPic.webPageBigHeight;
                    $scope.newsite.WEBZTPICSIZE = $scope.newPic.webPageZtWidth + ',' + $scope.newPic.webPageZtHeight;
                    $scope.newsite.ACTIVITYSIZE = $scope.newPic.activityWidth + ',' + $scope.newPic.activityHeight;
                    $scope.newsite.ACTIVITYBIGSIZE = $scope.newPic.activityBigWidth + ',' + $scope.newPic.activityBigHeight;
                    $scope.newsite.ACTIVITYZTPICSIZE = $scope.newPic.activityZtWidth + ',' + $scope.newPic.activityZtHeight;
                    $scope.newsite.TOPSIZE = $scope.newPic.topWidth + ',' + $scope.newPic.topHeight;
                    $scope.newsite.TOPBIGSIZE = $scope.newPic.topBigWidth + ',' + $scope.newPic.topBigHeight;
                    $scope.newsite.TOPZTPICSIZE = $scope.newPic.topZtWidth + ',' + $scope.newPic.topZtHeight;
                    $scope.newsite.VIDEOSIZE = $scope.newPic.videoWidth + ',' + $scope.newPic.videoHeight;
                    $scope.newsite.VIDEOBIGSIZE = $scope.newPic.videoBigWidth + ',' + $scope.newPic.videoBigHeight;
                    $scope.newsite.VIDEOZTPICSIZE = $scope.newPic.videoZtWidth + ',' + $scope.newPic.videoZtHeight;
                    $scope.newsite.VIDEOSSIZE = $scope.newPic.videosWidth + ',' + $scope.newPic.videosHeight;
                    $scope.newsite.VIDEOSBIGSIZE = $scope.newPic.videosBigWidth + ',' + $scope.newPic.videosBigHeight;
                    $scope.newsite.LIVESIZE = $scope.newPic.liveWidth + ',' + $scope.newPic.liveHeight;
                    $scope.newsite.LIVEBIGSIZE = $scope.newPic.liveBigWidth + ',' + $scope.newPic.liveBigHeight;
                    $scope.newsite.LIVEZTPICSIZE = $scope.newPic.liveZtWidth + ',' + $scope.newPic.liveZtHeight;
                    $scope.newsite.PICFOCUS = $scope.newPic.picFocusWidth + ',' + $scope.newPic.picFocusHeight;
                    $scope.newsite.SPECZTPICSIZE = $scope.newPic.specZtPicWidth + ',' + $scope.newPic.specZtPicHeight;
                    // $scope.newsite.PICBIGFOCUS = $scope.newPic.picBigFocusWidth + "," + $scope.newPic.picBigFocusHeight;
                    $scope.newsite.FOCUSIMAGESIZE = $scope.focus.focusWidth + ',' + $scope.focus.focusHeight;
                    $scope.newsite.FIGURESIZE = $scope.figure.figureWidth + ',' + $scope.figure.figureHeight;
                    $scope.newsite.SPECIALSIZE = $scope.figure.subjectWidth + ',' + $scope.figure.subjectHeight;
                    $scope.newsite.TOPICSIZE = $scope.figure.topicWidth + ',' + $scope.figure.topicHeight;
                    $scope.newsite.SiteName = $scope.newsite.SiteDesc;
                    $scope.newsite.SiteOrder = $scope.allSitesSelected.value;
                    $scope.newsite.ObjectId = angular.isDefined($scope.newsite.ObjectId) ? parseInt($scope.newsite.ObjectId) : 0;
                    $scope.newsite.TempId = JSON.stringify({
                        CHNLTEMPID: angular.isDefined($scope.temp) ? parseInt($scope.temp.TEMPID) : 0,
                        OTHERTEMPID: angular.isDefined($scope.otherTemp) ? parseInt($scope.otherTemp.TEMPID) : 0,
                        DOCTEMPID: angular.isDefined($scope.xilanTemp) ? parseInt($scope.xilanTemp.TEMPID) : 0,
                    });
                    $scope.newsite.repeatUseTime = $scope.newsite.repeatUseTime === '' ? 0 : $scope.newsite.repeatUseTime;
                    $scope.newsite.CKMSIMDAYRANGE = $scope.newsite.CKMSIMDAYRANGE === '' ? 0 : $scope.newsite.CKMSIMDAYRANGE;
                    formatComponentData();
                    if ($scope.isJudge && $scope.newsite.ISORIGINAL == '0') {
                        deleteProducts();
                    }
                    $modalInstance.close($scope.newsite);
                })
                .error(function() {
                    angular.invalidPosition($scope.addAndModForm, $element);
                });
        };

        /**
         * [deleteProducts description]删除
         *
         * @return  {[type]}  [return description]
         */
        function deleteProducts() {
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'deleteProduct',
                PRODUCTID: parseInt($scope.newsite.ObjectId),
                MEDIATYPE: 1,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {});
        }
        // 稿件是否排重
        $scope.checkAttr = function(type) {
            if (type == 'CheckFgdAttribute') {
                $scope.newsite.CheckFgdAttribute = $scope.newsite.CheckFgdAttribute === 1 ? 0 : 1;
            } else if (type == 'Ispaichong') {
                $scope.newsite.ISPAICHONG = $scope.newsite.ISPAICHONG === 1 ? 0 : 1;
            }
        };
      
        /**
         * [formatComponentData description]编辑器组件数据处理（保存时处理多余数据：处理系统管理中已经删除的配置项）
         * @param  {[type]} TEMPLATETYPE [description]
         * @return {[type]}              [description]
         */
        function formatComponentData() {
            var array = angular.copy($scope.newsite.APPMODULEID.split(','));
            var i = array.length - 1;
            while (i >= 0) {
                var flag = true;
                for (var j = 0; j < $scope.ueditorComponentsOrg.length; j++) {
                    if (array[i] === $scope.ueditorComponentsOrg[j].MODULENAME) {
                        flag = false;
                        break;
                    }
                }
                if (flag) {array.splice(i, 1);}
                i--;
            }
            $scope.newsite.APPMODULEID = array.join(',');
            delete $scope.newsite.otherTemp;
            delete $scope.newsite.picsize;
            delete $scope.newsite.temp;
        }
      
        /**
         * [queryTemplate description]模板弹窗打开
         *
         * @param   {[type]}  TEMPLATETYPE  [TEMPLATETYPE description]
         * @param   {[type]}  TEMP          [TEMP description]
         * @param   {[type]}  temp          [temp description]
         *
         * @return  {[type]}                [return description]
         */
        function queryTemplate(TEMPLATETYPE, TEMP, temp) {
            var params = {
                ObjectType: '103',
                ObjectId: $scope.newsite.ObjectId,
                TEMPLATETYPE: TEMPLATETYPE,
                TempName: '',
                selectedTempId: temp.TEMPID,
                selectedTempName: temp.TEMPNAME,
                // Tempid: temp.TEMPID,
            };
            productMangageMentAppService.bindTemplate(params, function(result) {
                $scope[TEMP] = result;
            });
        }

        /**
         * [channlViews description]站点首页模板点击
         *
         * @param   {[type]}  temp  [temp description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.channlViews = function(temp) {
            queryTemplate(1, 'temp', temp);
        };

        /**
         * [channlOtherViews description]其他首页模板点击
         *
         * @param   {[type]}  temp  [temp description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.channlOtherViews = function(temp) {
            queryTemplate(1, 'otherTemp', temp);
        };
      
        /**
         * [defaultArticleViews description]默认文章模板点击
         *
         * @param   {[type]}  temp  [temp description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.defaultArticleViews = function(temp) {
            queryTemplate(2, 'xilanTemp', temp);
        };

        /**
         * [attrAllChecks description] 稿件属性复选框
         * @param  {[type]} attr [description]
         * @return {[type]}      [description]
         */
        $scope.attrAllChecks = function(attr) {
            $scope.newsite[attr] = $scope.newsite[attr] === 1 ? 0 : 1;
        };

        /**
         * [checkIsPGC description]是否有PGC属性复选框
         *
         * @return {[type]} [description]
         */
        $scope.checkIsPGC = function() {
            $scope.newsite.ISPGC = $scope.newsite.ISPGC == 1 ? 0 : 1;
        };
        $scope.examineEngName = function() {
            var examParams = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'checkWebSitePath',
                DataPath: $scope.newsite.DataPath,
            };
            examParams.SiteId = angular.isDefined($scope.newsite.siteId) ? $scope.newsite.siteId : 0;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), examParams, 'get').then(function(data) {
                $scope.examEng = data;
            });
        };

        /**
         * [checkSiteName description] 校验站点名是否已经存在
         * @return {[type]} [description]
         */
        $scope.checkSiteName = function() {
            if ($scope.newsite.SiteDesc == $scope.thisSiteName || $scope.newsite.SiteDesc === '') {return;}
            var params = {
                serviceid: 'mlf_appconfig',
                methodname: 'checkSiteNameExists',
                SITENAME: $scope.newsite.SiteDesc,
                SITEID: $scope.thisSiteId || '0',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.isSiteExist = data;
            });
        };

        /** [description] 解决ngchange寻在的BUG问题 */
        $scope.$watch('newsite.SiteDesc', function() {
            if ($scope.newsite.SiteDesc === '') {
                $scope.isSiteExist = false;
            }
        });

        /**
         * [setUeditorComponent description] 设置编辑器组件
         * @param  {[string]} componentName [description] 组件名称
         * @return {[type]} [description]
         */
        $scope.setUeditorComponent = function(componentName) {
            var array = $scope.newsite.APPMODULEID === '' ? [] : $scope.newsite.APPMODULEID.split(',');
            if (array.indexOf(componentName) >= 0) {
                array.splice(array.indexOf(componentName), 1);
            } else {
                array.push(componentName);
            }
            $scope.newsite.APPMODULEID = array.join(',');
        };

        /**
         * [ueditorComponent description] 设置编辑器组件
         * @param  {[string]} componentName [description] 组件名称
         * @return {[type]} [description]
         */
        $scope.ueditorComponent = function(componentName) {

            /* var flag = false;
            var array = $scope.newsite.APPMODULEID.split(",");
            for (var i = 0; i < array.length; i++) {
                if (componentName === array[i]) flag = true;
                break;
            }
            return flag;*/
            return (
                angular
                    .copy($scope.newsite.APPMODULEID)
                    .split(',')
                    .indexOf(componentName) >= 0
            );
        };

        /**
         * [selectDropList description] 选中下拉选项
         * @param  {[string]} attributeName [description] 需要选中的属性名称
         * @return {[obj]} [description]
         */
        $scope.selectDropList = function(attributeName) {

            /* $scope.newsite.EDITORTYPEFACE = JSON.stringify($scope.EDITORTYPEFACECLONE);*/
            $scope.newsite[attributeName] = JSON.stringify($scope[attributeName + 'CLONE']);
        };

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.focus = {
                focusWidth: '16',
                focusHeight: '9',
            };
            $scope.figure = {
                figureWidth: '3', // 正文
                figureHeight: '1',
                subjectWidth: '3', // 专题题图
                subjectHeight: '1',
                topicWidth: '3', // 话题题图
                topicHeight: '1',
            };
            $scope.newPic = {
                newsPicWidth: '4', // 新闻稿列表图尺寸
                newsPicHeight: '3',
                newsZtPicWidth: '690', // 新闻窄图尺寸
                newsZtPicHeight: '160',
                picZtWidth: '690', // 图集稿大图尺寸
                picZtHeight: '160',
                newsBigPicWidth: '16', // 新闻稿大图尺寸
                newsBigPicHeight: '9',
                picWidth: '4', // 图集稿列表图尺寸
                picHeight: '3',
                picBigWidth: '16', // 图集稿大图尺寸
                picBigHeight: '9',
                specWidth: '4', // 专题稿列表图尺寸
                specHeight: '3',
                specBigWidth: '16', // 专题稿大图尺寸
                specBigHeight: '9',
                webPageWidth: '4', // 网页稿列表图尺寸
                webPageHeight: '3',
                webPageBigWidth: '16', // 网页稿大图尺寸
                webPageBigHeight: '9',
                webPageZtWidth: '690', // 网页链接稿窄图尺寸
                webPageZtHeight: '190',
                activityWidth: '4', // 活动稿列表图尺寸
                activityHeight: '3',
                activityBigWidth: '16', // 活动稿大图尺寸
                activityBigHeight: '9',
                activityZtWidth: '690', // 活动稿窄图尺寸
                activityZtHeight: '190',
                topWidth: '4', // 音频稿列表图尺寸
                topHeight: '3',
                topBigWidth: '16', // 音频稿大图尺寸
                topBigHeight: '9',
                topZtWidth: '690', // 音频稿大图尺寸
                topZtHeight: '190',
                videoWidth: '4', // 视频稿列表图尺寸
                videoHeight: '3',
                videoBigWidth: '16', // 视频稿大图尺寸
                videoBigHeight: '9',
                videoZtWidth: '690', // 视频稿窄图尺寸
                videoZtHeight: '190',
                liveWidth: '4', // 直播稿列表图尺寸
                liveHeight: '3',
                liveBigWidth: '16', // 直播稿大图尺寸
                liveBigHeight: '9',
                liveZtWidth: '690', // 直播稿窄图尺寸
                liveZtHeight: '190',
                picFocusWidth: '4', // 专题焦点图尺寸
                picFocusHeight: '3',
                specZtPicWidth: '690', // 专题窄图尺寸
                specZtPicHeight: '160',
                videosWidth: '4', // 视频专辑列表图尺寸
                videosHeight: '3',
                videosBigWidth: '16', // 视频专辑列表图尺寸
                videosBigHeight: '9',
                // focusWidth: "16", //焦点图尺寸
                // focusHeight: "9",
                // figureWidth: "16", //正文题图尺寸
                // figureHeight: "9",
                // subjectWidth: "16", //专题题图尺寸
                // subjectHeight: "9",
                // topicWidth: "16", //话题题图尺寸
                // topicHeight: "9"
            };
            $scope.title = params.title;
            $scope.allSites = [];
            $scope.isSiteExist = '"false"'; // 校验站点名是否已经存在
            $scope.examEng = 'true'; // 校验存放位置是否已经存在
            $scope.fontOptions = productMangageMentAppService.fontOptions(); // 编辑器字体选项列表
            $scope.lineSpacings = productMangageMentAppService.lineSpacings(); // 编辑器行间距选项列表
            $scope.fontSize = productMangageMentAppService.fontSize(); // 编辑器字体大小列表
            $scope.EDITORTYPEFACECLONE = $scope.fontOptions[6];
            $scope.ROWSPACINGSETTINGCLONE = $scope.lineSpacings[1];
            $scope.EDITORWORDSCLONE = $scope.fontSize[4];
            $scope.HEADLINEDOCREVIEW = 0; //    推头条配置审核
            angular.forEach(params.allSite, function(data, index, array) {
                $scope.allSites.push({
                    name: data.SITEDESC,
                    value: data.SITEORDER,
                });
            });
            $scope.allSites.unshift({
                name: '最前面',
                value: -1,
            });
            $scope.isJudge = false;
            if (params.siteInfo !== '') {
                $scope.newsite = params.siteInfo;
                $scope.newsite.APPMODULEID = $scope.newsite.APPMODULEID === undefined ? '' : $scope.newsite.APPMODULEID;
                $scope.newsite.EDITORTYPEFACE =
                    $scope.newsite.EDITORTYPEFACE === '' || $scope.newsite.EDITORTYPEFACE === undefined
                        ? '{ "name": "arial", "value": "arial" }'
                        : JSON.stringify($scope.newsite.EDITORTYPEFACE);
                $scope.EDITORTYPEFACECLONE = JSON.parse($scope.newsite.EDITORTYPEFACE);
                $scope.newsite.ROWSPACINGSETTING =
                    $scope.newsite.ROWSPACINGSETTING === '' || $scope.newsite.ROWSPACINGSETTING === undefined
                        ? '{ "name": "1.5", "value": "1.5" }'
                        : JSON.stringify($scope.newsite.ROWSPACINGSETTING);
                $scope.ROWSPACINGSETTINGCLONE = JSON.parse($scope.newsite.ROWSPACINGSETTING);
                $scope.newsite.EDITORWORDS =
                    $scope.newsite.EDITORWORDS === '' || $scope.newsite.EDITORWORDS === undefined
                        ? '{ "name": "16px", "value": "16px" }'
                        : JSON.stringify($scope.newsite.EDITORWORDS);
                $scope.EDITORWORDSCLONE = JSON.parse($scope.newsite.EDITORWORDS);
                $scope.newsite.PICTEXTTYPESET = isNaN($scope.newsite.PICTEXTTYPESET) ? 0 : $scope.newsite.PICTEXTTYPESET;
                $scope.temp = params.siteInfo.temp;
                $scope.newsite.ISPGC = params.siteInfo.ISPGC;
                $scope.otherTemp = params.siteInfo.otherTemp;
                $scope.xilanTemp = params.siteInfo.xilanTemp;
                $scope.thisSiteName = params.SiteName;
                $scope.thisSiteId = params.ObjectId;
                $scope.newsite.TYPEFACEDEFINITION = params.siteInfo.TYPEFACEDEFINITION;
                $scope.HEADLINEDOCREVIEW = params.siteInfo.HEADLINEDOCREVIEW;
                $scope.newsite.ISORIGINAL = params.siteInfo.ISORIGINAL;
                $scope.isJudge = $scope.newsite.ISORIGINAL == '1';
                // 处理编辑站点排序默认选中站点开始
                var i = 0;
                while (i < $scope.allSites.length) {
                    // 去除本站点在排序列表上展现，并且将本站点的前一个站点设为默认位置。
                    if ($scope.allSites[i].value === params.siteInfo.SiteOrder) {
                        $scope.allSites.splice(i, 1);
                        $scope.allSitesSelected = angular.copy($scope.allSites[i - 1]);
                    } else {
                        i++;
                    }
                }
                if (angular.isDefined(params.siteInfo.picsize)) {
                    $scope.newPic.newsPicWidth = params.siteInfo.picsize.NEWSPICSIZE.substr(0, params.siteInfo.picsize.NEWSPICSIZE.indexOf(','));
                    $scope.newPic.newsPicHeight = params.siteInfo.picsize.NEWSPICSIZE.substr(params.siteInfo.picsize.NEWSPICSIZE.indexOf(',') + 1);
                    $scope.newPic.newsZtPicWidth = params.siteInfo.picsize.NEWSZTPICSIZE.substr(0, params.siteInfo.picsize.NEWSZTPICSIZE.indexOf(','));
                    $scope.newPic.newsZtPicHeight = params.siteInfo.picsize.NEWSZTPICSIZE.substr(params.siteInfo.picsize.NEWSZTPICSIZE.indexOf(',') + 1);
                    $scope.newPic.picWidth = params.siteInfo.picsize.PICSIZE.substr(0, params.siteInfo.picsize.PICSIZE.indexOf(','));
                    $scope.newPic.picHeight = params.siteInfo.picsize.PICSIZE.substr(params.siteInfo.picsize.PICSIZE.indexOf(',') + 1);
                    $scope.newPic.specWidth = params.siteInfo.picsize.SPECSIZE.substr(0, params.siteInfo.picsize.SPECSIZE.indexOf(','));
                    $scope.newPic.specHeight = params.siteInfo.picsize.SPECSIZE.substr(params.siteInfo.picsize.SPECSIZE.indexOf(',') + 1);
                    $scope.newPic.webPageWidth = params.siteInfo.picsize.WEBPAGESIZE.substr(0, params.siteInfo.picsize.WEBPAGESIZE.indexOf(','));
                    $scope.newPic.webPageHeight = params.siteInfo.picsize.WEBPAGESIZE.substr(params.siteInfo.picsize.WEBPAGESIZE.indexOf(',') + 1);
                    $scope.newPic.activityWidth = params.siteInfo.picsize.ACTIVITYSIZE.substr(0, params.siteInfo.picsize.ACTIVITYSIZE.indexOf(','));
                    $scope.newPic.activityHeight = params.siteInfo.picsize.ACTIVITYSIZE.substr(params.siteInfo.picsize.ACTIVITYSIZE.indexOf(',') + 1);
                    $scope.newPic.topWidth = params.siteInfo.picsize.TOPSIZE.substr(0, params.siteInfo.picsize.TOPSIZE.indexOf(','));
                    $scope.newPic.topHeight = params.siteInfo.picsize.TOPSIZE.substr(params.siteInfo.picsize.TOPSIZE.indexOf(',') + 1);
                    $scope.newPic.videoWidth = params.siteInfo.picsize.VIDEOSIZE.substr(0, params.siteInfo.picsize.VIDEOSIZE.indexOf(','));
                    $scope.newPic.videoHeight = params.siteInfo.picsize.VIDEOSIZE.substr(params.siteInfo.picsize.VIDEOSIZE.indexOf(',') + 1);
                    $scope.newPic.videosWidth = params.siteInfo.picsize.VIDEOSSIZE.substr(0, params.siteInfo.picsize.VIDEOSSIZE.indexOf(','));
                    $scope.newPic.videosHeight = params.siteInfo.picsize.VIDEOSSIZE.substr(params.siteInfo.picsize.VIDEOSSIZE.indexOf(',') + 1);
                    $scope.newPic.liveWidth = params.siteInfo.picsize.LIVESIZE.substr(0, params.siteInfo.picsize.LIVESIZE.indexOf(','));
                    $scope.newPic.liveHeight = params.siteInfo.picsize.LIVESIZE.substr(params.siteInfo.picsize.LIVESIZE.indexOf(',') + 1);
                    $scope.newPic.picFocusWidth = params.siteInfo.picsize.PICFOCUS.substr(0, params.siteInfo.picsize.PICFOCUS.indexOf(','));
                    $scope.newPic.picFocusHeight = params.siteInfo.picsize.PICFOCUS.substr(params.siteInfo.picsize.PICFOCUS.indexOf(',') + 1);
                    $scope.focus.focusWidth = params.siteInfo.picsize.FOCUSIMAGESIZE.substr(0, params.siteInfo.picsize.FOCUSIMAGESIZE.indexOf(','));
                    $scope.focus.focusHeight = params.siteInfo.picsize.FOCUSIMAGESIZE.substr(params.siteInfo.picsize.FOCUSIMAGESIZE.indexOf(',') + 1);
                    $scope.figure.figureWidth = params.siteInfo.picsize.FIGURESIZE.substr(0, params.siteInfo.picsize.FIGURESIZE.indexOf(','));
                    $scope.figure.figureHeight = params.siteInfo.picsize.FIGURESIZE.substr(params.siteInfo.picsize.FIGURESIZE.indexOf(',') + 1);
                    $scope.figure.subjectWidth =
                        $scope.newsite.picsize.SPECIALSIZE === '' || $scope.newsite.picsize.SPECIALSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.SPECIALSIZE.split(',')[0];
                    $scope.figure.subjectHeight =
                        $scope.newsite.picsize.SPECIALSIZE === '' || $scope.newsite.picsize.SPECIALSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.SPECIALSIZE.split(',')[1];
                    $scope.figure.topicWidth =
                        $scope.newsite.picsize.TOPICSIZE === '' || $scope.newsite.picsize.TOPICSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.TOPICSIZE.split(',')[0];
                    $scope.figure.topicHeight =
                        $scope.newsite.picsize.TOPICSIZE === '' || $scope.newsite.picsize.TOPICSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.TOPICSIZE.split(',')[1];

                    $scope.newPic.newsBigPicWidth = params.siteInfo.picsize.NEWSBIGPICSIZE.substr(
                        0,
                        params.siteInfo.picsize.NEWSBIGPICSIZE.indexOf(',')
                    );
                    $scope.newPic.newsBigPicHeight = params.siteInfo.picsize.NEWSBIGPICSIZE.substr(
                        params.siteInfo.picsize.NEWSBIGPICSIZE.indexOf(',') + 1
                    );
                    $scope.newPic.picBigWidth = params.siteInfo.picsize.PICBIGSIZE.substr(0, params.siteInfo.picsize.PICBIGSIZE.indexOf(','));
                    $scope.newPic.picBigHeight = params.siteInfo.picsize.PICBIGSIZE.substr(params.siteInfo.picsize.PICBIGSIZE.indexOf(',') + 1);
                    $scope.newPic.picZtWidth = params.siteInfo.picsize.PICZTPICSIZE.substr(0, params.siteInfo.picsize.PICZTPICSIZE.indexOf(','));
                    $scope.newPic.picZtHeight = params.siteInfo.picsize.PICZTPICSIZE.substr(params.siteInfo.picsize.PICZTPICSIZE.indexOf(',') + 1);
                    $scope.newPic.specBigWidth = params.siteInfo.picsize.SPECBIGSIZE.substr(0, params.siteInfo.picsize.SPECBIGSIZE.indexOf(','));
                    $scope.newPic.specBigHeight = params.siteInfo.picsize.SPECBIGSIZE.substr(params.siteInfo.picsize.SPECBIGSIZE.indexOf(',') + 1);
                    $scope.newPic.webPageBigWidth = params.siteInfo.picsize.WEBPAGEBIGSIZE.substr(
                        0,
                        params.siteInfo.picsize.WEBPAGEBIGSIZE.indexOf(',')
                    );
                    $scope.newPic.webPageBigHeight = params.siteInfo.picsize.WEBPAGEBIGSIZE.substr(
                        params.siteInfo.picsize.WEBPAGEBIGSIZE.indexOf(',') + 1
                    );
                    $scope.newPic.webPageZtWidth = params.siteInfo.picsize.WEBZTPICSIZE.substr(
                        0,
                        params.siteInfo.picsize.WEBZTPICSIZE.indexOf(',')
                    );
                    $scope.newPic.webPageZtHeight = params.siteInfo.picsize.WEBZTPICSIZE.substr(
                        params.siteInfo.picsize.WEBZTPICSIZE.indexOf(',') + 1
                    );
                    $scope.newPic.activityBigWidth = params.siteInfo.picsize.ACTIVITYBIGSIZE.substr(
                        0,
                        params.siteInfo.picsize.ACTIVITYBIGSIZE.indexOf(',')
                    );
                    $scope.newPic.activityBigHeight = params.siteInfo.picsize.ACTIVITYBIGSIZE.substr(
                        params.siteInfo.picsize.ACTIVITYBIGSIZE.indexOf(',') + 1
                    );
                    $scope.newPic.activityZtWidth = params.siteInfo.picsize.ACTIVITYZTPICSIZE.substr(
                        0,
                        params.siteInfo.picsize.ACTIVITYZTPICSIZE.indexOf(',')
                    );
                    $scope.newPic.activityZtHeight = params.siteInfo.picsize.ACTIVITYZTPICSIZE.substr(
                        params.siteInfo.picsize.ACTIVITYZTPICSIZE.indexOf(',') + 1
                    );
                    $scope.newPic.topBigWidth = params.siteInfo.picsize.TOPBIGSIZE.substr(0, params.siteInfo.picsize.TOPBIGSIZE.indexOf(','));
                    $scope.newPic.topBigHeight = params.siteInfo.picsize.TOPBIGSIZE.substr(params.siteInfo.picsize.TOPBIGSIZE.indexOf(',') + 1);
                    $scope.newPic.topZtWidth = params.siteInfo.picsize.TOPZTPICSIZE.substr(0, params.siteInfo.picsize.TOPZTPICSIZE.indexOf(','));
                    $scope.newPic.topZtHeight = params.siteInfo.picsize.TOPZTPICSIZE.substr(params.siteInfo.picsize.TOPZTPICSIZE.indexOf(',') + 1);
                    $scope.newPic.videoBigWidth = params.siteInfo.picsize.VIDEOBIGSIZE.substr(0, params.siteInfo.picsize.VIDEOBIGSIZE.indexOf(','));
                    $scope.newPic.videoBigHeight = params.siteInfo.picsize.VIDEOBIGSIZE.substr(params.siteInfo.picsize.VIDEOBIGSIZE.indexOf(',') + 1);
                    $scope.newPic.videoZtWidth = params.siteInfo.picsize.VIDEOZTPICSIZE.substr(0, params.siteInfo.picsize.VIDEOZTPICSIZE.indexOf(','));
                    $scope.newPic.videoZtHeight = params.siteInfo.picsize.VIDEOZTPICSIZE.substr(params.siteInfo.picsize.VIDEOZTPICSIZE.indexOf(',') + 1);
                    $scope.newPic.videosBigWidth = params.siteInfo.picsize.VIDEOSBIGSIZE.substr(
                        0,
                        params.siteInfo.picsize.VIDEOSBIGSIZE.indexOf(',')
                    );
                    $scope.newPic.videosBigHeight = params.siteInfo.picsize.VIDEOSBIGSIZE.substr(
                        params.siteInfo.picsize.VIDEOSBIGSIZE.indexOf(',') + 1
                    );
                    $scope.newPic.liveBigWidth = params.siteInfo.picsize.LIVEBIGSIZE.substr(0, params.siteInfo.picsize.LIVEBIGSIZE.indexOf(','));
                    $scope.newPic.liveBigHeight = params.siteInfo.picsize.LIVEBIGSIZE.substr(params.siteInfo.picsize.LIVEBIGSIZE.indexOf(',') + 1);
                    $scope.newPic.liveZtWidth = params.siteInfo.picsize.LIVEZTPICSIZE.substr(0, params.siteInfo.picsize.LIVEZTPICSIZE.indexOf(','));
                    $scope.newPic.liveZtHeight = params.siteInfo.picsize.LIVEZTPICSIZE.substr(params.siteInfo.picsize.LIVEZTPICSIZE.indexOf(',') + 1);
                    // $scope.newPic.picBigFocusWidth = params.siteInfo.picsize.PICBIGFOCUS.substr(0, params.siteInfo.picsize.PICBIGFOCUS.indexOf(','));
                    // $scope.newPic.picBigFocusHeight = params.siteInfo.picsize.PICBIGFOCUS.substr(params.siteInfo.picsize.PICBIGFOCUS.indexOf(',') + 1);
                    $scope.focus.focusWidth = params.siteInfo.picsize.FOCUSIMAGESIZE.substr(0, params.siteInfo.picsize.FOCUSIMAGESIZE.indexOf(','));
                    $scope.focus.focusHeight = params.siteInfo.picsize.FOCUSIMAGESIZE.substr(params.siteInfo.picsize.FOCUSIMAGESIZE.indexOf(',') + 1);
                    $scope.figure.figureWidth = params.siteInfo.picsize.FIGURESIZE.substr(0, params.siteInfo.picsize.FIGURESIZE.indexOf(','));
                    $scope.figure.figureHeight = params.siteInfo.picsize.FIGURESIZE.substr(params.siteInfo.picsize.FIGURESIZE.indexOf(',') + 1);
                    $scope.figure.subjectWidth =
                        $scope.newsite.picsize.SPECIALSIZE === '' || $scope.newsite.picsize.SPECIALSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.SPECIALSIZE.split(',')[0];
                    $scope.figure.subjectHeight =
                        $scope.newsite.picsize.SPECIALSIZE === '' || $scope.newsite.picsize.SPECIALSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.SPECIALSIZE.split(',')[1];
                    $scope.figure.topicWidth =
                        $scope.newsite.picsize.TOPICSIZE === '' || $scope.newsite.picsize.TOPICSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.TOPICSIZE.split(',')[0];
                    $scope.figure.topicHeight =
                        $scope.newsite.picsize.TOPICSIZE === '' || $scope.newsite.picsize.TOPICSIZE === undefined
                            ? ''
                            : $scope.newsite.picsize.TOPICSIZE.split(',')[1];
                }
            } else {
                $scope.allSitesSelected = angular.copy($scope.allSites[0]);
                $scope.newsite = {
                    CheckFgdAttribute: 0,
                    ExternalSys: 0,
                    repeatUseTime: 0,
                    IsSecondReview: 0,
                    RelatedTopic: 0,
                    ConnectionColumn: 0,
                    RelatedOfficial: 0,
                    isTrashPubDoc: 0,
                    ISPGC: 0,
                    PICTEXTTYPESET: 0,
                    CKMSIMDAYRANGE: 0,
                    ISPAICHONG: 0,
                    APPMODULEID: '',
                    EDITORTYPEFACE: '{ "name": "arial", "value": "arial" }',
                    ROWSPACINGSETTING: '{ "name": "1.5", "value": "1.5" }',
                    EDITORWORDS: '{ "name": "16px", "value": "16px" }',
                    ISORIGINAL: '1',
                };
            }
            getUeditorComponents();
        }

        /**
         * [getUeditorComponents description] 获取编辑器组件类型
         * @return {[obj]} [description]1
         */
        function getUeditorComponents() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_appmodule',
                methodname: 'queryAllAppModule',
                isPage: 1,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                // $scope.status.ueditorComponents = data.DATA;
                $scope.ueditorComponentsOrg = data;
                var array = [];
                var j = 0;
                for (var i = 0; i < data.length; i++) {
                    // 将返回的一维数组变为二维数组，方便页面渲染
                    if (!angular.isArray(array[j])) {array[j] = [];}
                    array[j].push(data[i]);
                    if ((i + 1) % 3 === 0) {j++;}
                }
                $scope.ueditorComponents = array;
            });
        }
    },
]);
